import {Route, Routes,Navigate } from "react-router-dom";
import AdminLayout from "layouts/Admin.jsx";
import Login from "../views/Login";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import Recuperar from "views/Recuperar";
import ActualizarContrasena from "views/ActualizarContrasena";
export const AppRouter=()=>{
  
return (
<>
    <Routes>
        <Route path="/login/*" element={
            <PublicRoute>
            {/*<Login />*/}
            <Routes>
                    <Route path="/*" element={<Login />} />
                  </Routes>
            </PublicRoute>
        } />
        <Route path="/recuperar" element={
            <PublicRoute>
            <Recuperar />
            </PublicRoute>
        } />

        <Route path="/ActualizarContrasena" element={
            <PrivateRoute>
                <ActualizarContrasena></ActualizarContrasena>
            </PrivateRoute>
            } 
        />

        <Route path="/admin/*" element={
            <PrivateRoute>
                <AdminLayout />
            </PrivateRoute>
            } 
        />

      <Route path="/" element={
            <PublicRoute>
                <Navigate replace to="/login" />
            </PublicRoute>
        } />  
    </Routes>
</>

)

}

